import { api } from '@/config/index.js'
import httpApi from '@/utils/http-api.js'

export default {
  getAffiliateConfigs: () => {
    return httpApi.getDataViaApi({
      url: api.common.contentAffiliate
    })
  }
}
